module.exports = __webpack_public_path__ + "img/panamera@2x.067c658b.jpeg";